// extracted by mini-css-extract-plugin
module.exports = {"specsCol":"specs-module--specsCol--yjhvb","specsCat":"specs-module--specsCat--2Cqzf","specsRow":"specs-module--specsRow--2XFyh"};